(() => {
  const init = () => {
    document.querySelectorAll('variant-picker[form-id]').forEach((picker) => attach(picker));
  };

  const attach = (picker) => {
    if (picker.dataset.validationAttached === 'true') return;
    picker.dataset.validationAttached = 'true';

    const formId = picker.getAttribute('form-id');
    if (!formId) return;

    const form = document.getElementById(formId);

    // Query the LIVE picker each call. The picker is replaced on partial rerender after
    // a variant change, and the original `picker` closure captures the old (now detached)
    // element. On mobile that bug also strands the popover in <body>, so the old picker
    // looks empty → validation thinks every option is missing and swallows the ATC click.
    const livePicker = () => document.querySelector(`variant-picker[form-id="${formId}"]`) || picker;

    const getMissingGroups = () => {
      const radios = document.querySelectorAll(`input[type="radio"][data-option-position][form="${formId}"]`);
      const groups = new Map();
      radios.forEach((radio) => {
        const pos = radio.dataset.optionPosition;
        if (!groups.has(pos)) groups.set(pos, { checked: false, radios: [] });
        const g = groups.get(pos);
        g.radios.push(radio);
        if (radio.checked) g.checked = true;
      });
      return [...groups.values()].filter((g) => !g.checked);
    };

    const setInvalid = (fieldset, invalid) => {
      fieldset.classList.toggle('variant-picker__option--invalid', invalid);
      const error = fieldset.querySelector('[data-variant-error]');
      if (error) error.hidden = !invalid;
    };

    const clearErrors = () => {
      livePicker().querySelectorAll('.variant-picker__option--invalid').forEach((el) => setInvalid(el, false));
    };

    const markInvalid = (missing) => {
      clearErrors();
      missing.forEach((g) => {
        const fieldset = g.radios[0]?.closest('fieldset.variant-picker__option, .variant-picker__option');
        if (fieldset) setInvalid(fieldset, true);
      });
    };

    // Outline the missing option(s) in red and bring the first into view (no button greying).
    const flagMissing = (missing) => {
      markInvalid(missing);
      const firstMissing = missing[0];
      const fieldset = firstMissing?.radios[0]?.closest('fieldset.variant-picker__option, .variant-picker__option');
      if (fieldset) {
        fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const focusTarget = fieldset.querySelector('button, [tabindex]:not([tabindex="-1"]), input:not([type="hidden"])') || firstMissing.radios[0];
        focusTarget?.focus?.({ preventScroll: true });
      }
    };

    // Clear red on an option as soon as the user picks a value in that option.
    // Listen on document so we catch radios that have moved (e.g. <x-popover> appended to body on mobile).
    document.addEventListener('change', (event) => {
      const radio = event.target;
      if (!radio?.matches?.(`input[type="radio"][data-option-position][form="${formId}"]`)) return;
      const fieldset = radio.closest('fieldset.variant-picker__option, .variant-picker__option');
      if (fieldset) setInvalid(fieldset, false);
    });

    // When a size-guide simulator drives this picker (<size-guide-*>), its own submit
    // guard owns the blocking + feedback (including the "no valid PERCKO size" fallback
    // message). Skip here so we don't preempt it with a generic, feedback-less block.
    const ownedBySizeGuide = () => !!livePicker().querySelector('size-guide-woman, size-guide-man, size-guide-bra');

    if (form) {
      // Main submit buttons live inside the form — intercept the click.
      form.addEventListener('click', (event) => {
        const btn = event.target.closest('button[type="submit"], .shopify-payment-button__button');
        if (!btn || !form.contains(btn)) return;
        if (ownedBySizeGuide()) return;

        const missing = getMissingGroups();
        if (missing.length === 0) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        flagMissing(missing);
      }, true);

      // The size-guide drawer's "Ajouter au panier" sits outside the form and submits via
      // requestSubmit(), so the click guard never sees it — catch the submit at capture.
      form.addEventListener('submit', (event) => {
        if (ownedBySizeGuide()) return;

        const missing = getMissingGroups();
        if (missing.length === 0) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        flagMissing(missing);
      }, true);
    }

    const backorderThreshold = Math.abs(parseInt(livePicker().dataset.backorderThreshold, 10) || 0);

    // A variant is treated as OOS (not backorder) when:
    // - inventory policy is deny, or
    // - threshold is set and stock has dropped below -threshold
    const isThresholdExceeded = (variant) => {
      if (backorderThreshold <= 0) return false;
      return (variant.inventory_quantity ?? 0) <= -backorderThreshold;
    };

    const isSoldOut = (variant) =>
      isThresholdExceeded(variant) ||
      (variant.available === false && variant.custom?.inventory_policy !== 'continue');

    const setSoldOutState = (soldOut) => {
      const buyButtonsEl = document.querySelector(`buy-buttons[form="${formId}"]`);
      const message = buyButtonsEl?.querySelector('.variant-picker__sold-out-message');
      if (message) {
        if (soldOut) {
          message.removeAttribute('hidden');
        } else {
          message.setAttribute('hidden', '');
        }
      }
      if (buyButtonsEl) buyButtonsEl.dataset.soldOut = soldOut ? 'true' : 'false';
      picker.classList.toggle('variant-picker--sold-out', soldOut);
      // Re-query after each variant re-render to avoid stale DOM references.
      const currentSection = livePicker().closest('[id^="shopify-section-"]');
      currentSection?.querySelectorAll('multi-add-to-cart, offer-pack').forEach(el => el.classList.toggle('multi-add--sold-out', soldOut));
    };

    const variantScript = picker.querySelector('script[data-variant]');
    if (variantScript) {
      const initialVariant = JSON.parse(variantScript.textContent || '{}');
      setSoldOutState(isSoldOut(initialVariant));
    }

    document.addEventListener('variant:change', (event) => {
      if (event.target?.getAttribute?.('id') !== formId) return;
      const variant = event.detail?.variant;
      setSoldOutState(variant ? isSoldOut(variant) : false);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
